'use client';

import Image from 'next/image';
import { Button } from '@/components/ui/button';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';

export default function OrderPage() {
  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      <Navbar />

      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-red-50 to-white py-12 sm:py-16 px-4">
          <div className="container mx-auto max-w-3xl">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-red-600 text-center mb-6 uppercase tracking-tight">
              Order Now
            </h1>
            <p className="text-center text-gray-700 text-xl sm:text-2xl font-bold mb-8">
              Your couch just became the best burger spot in the city!
            </p>

            {/* Promotional Burger Image */}
            <div className="mb-12 sm:mb-16 flex justify-center">
              <div className="relative w-full max-w-md rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg">
                <Image
                  src="/images/uploads/77616de4-e36a-41e8-a238-6f3f80bf7d95.jpg"
                  alt="Mo's Burger - Delicious Smash Burger"
                  width={500}
                  height={400}
                  className="w-full h-auto object-cover"
                  sizes="(max-width: 768px) 100vw, (max-width: 1024px) 90vw, 500px"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Ordering Platforms */}
        <section className="py-16 sm:py-20 px-4">
          <div className="container mx-auto max-w-4xl">
            {/* Toast - Primary Option */}
            <div className="mb-10 sm:mb-12">
              <h2 className="text-center text-foreground/60 text-sm font-bold uppercase tracking-widest mb-6">Primary Ordering</h2>
              <div className="bg-white rounded-2xl sm:rounded-3xl border-2 border-red-300 p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all">
                <div className="text-center">
                  <div className="mb-4 h-20 flex items-center justify-center">
                    <Image
                      src="/images/generated/icon-toast-logo.png"
                      alt="Toast Logo"
                      width={80}
                      height={80}
                      className="h-20 w-auto object-contain"
                    />
                  </div>
                  <h2 className="text-2xl sm:text-3xl font-black text-gray-900 mb-3">Toast</h2>
                  <p className="text-gray-700 font-medium mb-6">
                    Order directly from our Toast platform
                  </p>
                  <Button
                    onClick={() => window.open('https://www.toasttab.com/local/order/mos-burger-llc-3709-s-george-mason-dr-1204e', '_blank')}
                    className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-black text-base sm:text-lg py-5 sm:py-6 shadow-lg hover:shadow-xl transition-all"
                  >
                    Order on Toast
                  </Button>
                </div>
              </div>
            </div>

            {/* Delivery Options */}
            <div>
              <h2 className="text-center text-foreground/60 text-sm font-bold uppercase tracking-widest mb-6">Delivery Options</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
              {/* DoorDash */}
              <div className="bg-white rounded-2xl sm:rounded-3xl border-2 border-red-300 p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all">
                <div className="text-center">
                  <div className="mb-4 h-20 flex items-center justify-center">
                    <Image
                      src="/images/generated/icon-doordash-logo.png"
                      alt="DoorDash Logo"
                      width={80}
                      height={80}
                      className="h-20 w-auto object-contain"
                    />
                  </div>
                  <h2 className="text-2xl sm:text-3xl font-black text-gray-900 mb-3">DoorDash</h2>
                  <p className="text-gray-700 font-medium mb-6">
                    Order for delivery via DoorDash
                  </p>
                  <Button
                    onClick={() => window.open('https://www.doordash.com/store/37328131?src=yp&delivery=true&utm_source_id=3a4b9245-6353-4f6b-825a-695d0e735a11', '_blank')}
                    className="w-full bg-white border-2 border-red-600 text-red-600 hover:bg-red-50 font-black text-base sm:text-lg py-5 sm:py-6 shadow-lg hover:shadow-xl transition-all"
                  >
                    Order on DoorDash
                  </Button>
                </div>
              </div>

              {/* Uber Eats */}
              <div className="bg-white rounded-2xl sm:rounded-3xl border-2 border-red-300 p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all">
                <div className="text-center">
                  <div className="mb-4 h-20 flex items-center justify-center">
                    <Image
                      src="/images/generated/icon-uber-eats-logo.png"
                      alt="Uber Eats Logo"
                      width={80}
                      height={80}
                      className="h-20 w-auto object-contain"
                    />
                  </div>
                  <h2 className="text-2xl sm:text-3xl font-black text-gray-900 mb-3">Uber Eats</h2>
                  <p className="text-gray-700 font-medium mb-6">
                    Order for delivery via Uber Eats
                  </p>
                  <Button
                    onClick={() => window.open('https://www.ubereats.com/store/mos-burger-500-florida-avenue-northeast/OBre9dneUZSHCeqYN2bBMQ?diningMode=DELIVERY&ps=1&surfaceName=', '_blank')}
                    className="w-full bg-white border-2 border-red-600 text-red-600 hover:bg-red-50 font-black text-base sm:text-lg py-5 sm:py-6 shadow-lg hover:shadow-xl transition-all"
                  >
                    Order on Uber Eats
                  </Button>
                </div>
              </div>

              {/* Grubhub */}
              <div className="bg-white rounded-2xl sm:rounded-3xl border-2 border-red-300 p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all">
                <div className="text-center">
                  <div className="mb-4 h-20 flex items-center justify-center">
                    <Image
                      src="/images/generated/icon-grubhub-logo.png"
                      alt="Grubhub Logo"
                      width={80}
                      height={80}
                      className="h-20 w-auto object-contain"
                    />
                  </div>
                  <h2 className="text-2xl sm:text-3xl font-black text-gray-900 mb-3">Grubhub</h2>
                  <p className="text-gray-700 font-medium mb-6">
                    Order for delivery via Grubhub
                  </p>
                  <Button
                    onClick={() => window.open('https://www.grubhub.com', '_blank')}
                    className="w-full bg-red-600 hover:bg-red-700 text-white font-black text-base sm:text-lg py-5 sm:py-6 border-2 border-red-700 shadow-lg hover:shadow-xl transition-all"
                  >
                    Order on Grubhub
                  </Button>
                </div>
              </div>
            </div>
            </div>
          </div>
        </section>

        {/* Info Section */}
        <section className="bg-gray-50 py-16 sm:py-20 px-4">
          <div className="container mx-auto max-w-3xl text-center">
            <h2 className="text-2xl sm:text-3xl font-black text-red-600 mb-4 uppercase">Location</h2>
            <p className="text-gray-700 font-semibold mb-6 text-lg">
              To Be Announced
            </p>
            <p className="text-gray-600 text-base sm:text-lg font-medium">
              Follow us on Instagram @mosburgerdmv for location and hours updates
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
